function f(n) {
  return n instanceof Error || typeof n == "object" && !!(n != null && n.message);
}
function i(n) {
  return typeof (n == null ? void 0 : n.message) == "string";
}
function c(n, s, t) {
  if (f(n)) {
    const e = n;
    return s && (e.code = s), t && (e.additionalData = t), e;
  }
  const o = new Error("Unknown error");
  return t && (o.additionalData = t), i(n) ? (n.message && (o.message = n.message), o) : (typeof n == "string" && (o.message = n, s && (o.code = s)), o);
}
export {
  c as default
};
